import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CampaignActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Campaign/CampaignBrowser")
	}

	render() {
		return (
			<Activity 
				name="Campaign"
				RenderedComponent={this.RenderedComponent}
                context="Campaign"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CampaignActivity)
